/** Riven canvas painter stub. */
export class RivenPainter {
  static draw(ctx, entity, teamColor) {
    ctx.fillStyle = teamColor || '#a78bfa';
    ctx.beginPath();
    ctx.arc(entity.x, entity.y, entity.radius || 20, 0, Math.PI * 2);
    ctx.fill();
  }
}
